export default __webpack_public_path__ + "static/media/map.5a4139ab.png";